// Custom select: replaces every native <select> inside the store with a styled,
// searchable, keyboard-accessible listbox. The native element stays in the DOM
// (visually hidden) so forms, `name`, `onchange` auto-submit and validation work.
//   <option data-icon="battery" data-count="593" data-sub="Laptop Batteries">
import { $$, esc, t } from "./util";

let openInst = null;

function optHTML(o, i, selected) {
	const ic = o.dataset.icon, ph = o.dataset.photo;
	return `<li role="option" id="${o.parentElement.id || "ds"}-o${i}" data-i="${i}" aria-selected="${selected}" class="ds-sel__opt${selected ? " is-sel" : ""}${o.disabled ? " is-dis" : ""}">
		${ph ? `<span class="ds-sel__art"><img data-src="${esc(ph)}" alt="" decoding="async"></span>` : ic ? `<span class="ds-sel__art"><svg viewBox="0 0 160 120"><use href="#part-${esc(ic)}"/></svg></span>` : ""}
		<span class="ds-sel__txt"><b>${esc(o.textContent.trim())}</b>${o.dataset.sub ? `<small>${esc(o.dataset.sub)}</small>` : ""}</span>
		${o.dataset.count ? `<span class="ds-sel__count">${esc(o.dataset.count)}</span>` : ""}
		<svg class="di ds-sel__check" aria-hidden="true"><use href="#di-check"/></svg></li>`;
}

function enhance(sel) {
	if (sel.dataset.enhanced || sel.multiple) return;
	sel.dataset.enhanced = "1";
	if (!sel.id) sel.id = "dsel-" + Math.random().toString(36).slice(2, 8);
	const wrap = document.createElement("div");
	wrap.className = "ds-sel";
	sel.parentNode.insertBefore(wrap, sel);
	wrap.appendChild(sel);
	sel.classList.add("ds-sel__native");
	sel.tabIndex = -1;
	sel.setAttribute("aria-hidden", "true");

	const opts = Array.from(sel.options);
	const searchable = opts.length > 8;
	const label = sel.closest("label")?.querySelector("span")?.textContent?.trim() || sel.getAttribute("aria-label") || "";
	wrap.insertAdjacentHTML("beforeend", `
		<button type="button" class="ds-sel__btn" aria-haspopup="listbox" aria-expanded="false" aria-label="${esc(label)}">
			<span class="ds-sel__val"></span><svg class="di ds-sel__chev" aria-hidden="true"><use href="#di-chevron"/></svg></button>
		<div class="ds-sel__pop" hidden data-lenis-prevent>
			${searchable ? `<div class="ds-sel__search"><svg class="di"><use href="#di-search"/></svg><input type="text" autocomplete="off" placeholder="${t("ابحث…", "Search…")}" aria-label="${t("بحث", "Search")}"></div>` : ""}
			<ul class="ds-sel__list" role="listbox" tabindex="-1">${opts.map((o, i) => optHTML(o, i, o.selected)).join("")}</ul>
			<p class="ds-sel__empty" hidden>${t("لا توجد نتائج", "No matches")}</p>
		</div>`);
	const btn = wrap.querySelector(".ds-sel__btn");
	const pop = wrap.querySelector(".ds-sel__pop");
	const list = wrap.querySelector(".ds-sel__list");
	const search = wrap.querySelector(".ds-sel__search input");
	const val = wrap.querySelector(".ds-sel__val");
	let active = sel.selectedIndex;
	let raised = [];

	const paint = () => {
		const o = sel.options[sel.selectedIndex];
		const ic = o?.dataset.icon, ph = o?.dataset.photo;
		val.innerHTML = (ph ? `<span class="ds-sel__art ds-sel__art--sm"><img src="${esc(ph)}" alt=""></span>` : ic ? `<span class="ds-sel__art ds-sel__art--sm"><svg viewBox="0 0 160 120"><use href="#part-${esc(ic)}"/></svg></span>` : "") + `<span>${esc(o ? o.textContent.trim() : "")}</span>`;
		wrap.classList.toggle("is-empty", !o || !o.value);
		list.querySelectorAll(".ds-sel__opt").forEach((li) => { const s = +li.dataset.i === sel.selectedIndex; li.classList.toggle("is-sel", s); li.setAttribute("aria-selected", s); });
	};
	const visible = () => Array.from(list.querySelectorAll(".ds-sel__opt:not([hidden]):not(.is-dis)"));
	const setActive = (i) => {
		list.querySelectorAll(".is-act").forEach((x) => x.classList.remove("is-act"));
		const li = list.querySelector(`[data-i="${i}"]`);
		if (!li) return;
		active = i; li.classList.add("is-act"); btn.setAttribute("aria-activedescendant", li.id);
		li.scrollIntoView({ block: "nearest" });
	};
	const open = () => {
		if (openInst && openInst !== close) openInst();
		pop.hidden = false; wrap.classList.add("is-open"); btn.setAttribute("aria-expanded", "true");
		pop.querySelectorAll("img[data-src]").forEach((im) => { im.src = im.dataset.src; im.removeAttribute("data-src"); });  // photos load on first open
		raised = [];
		for (let el = wrap.parentElement; el && el !== document.body; el = el.parentElement) {
			if (el.matches("section, [data-reveal], .ds-finder, .ds-finder__form, .ds-filters, .ds-toolbar, .ds-pagehero")) { el.classList.add("ds-raise"); raised.push(el); }
		}
		const r = btn.getBoundingClientRect();
		wrap.classList.toggle("is-up", innerHeight - r.bottom < 320 && r.top > innerHeight - r.bottom);
		setActive(sel.selectedIndex);
		(search || list).focus({ preventScroll: true });
		openInst = close;
	};
	const close = (focusBtn) => {
		if (pop.hidden) return;
		wrap.classList.remove("is-open"); btn.setAttribute("aria-expanded", "false");
		raised.forEach((el) => el.classList.remove("ds-raise")); raised = [];
		pop.hidden = true;
		if (search) { search.value = ""; filter(""); }
		if (focusBtn) btn.focus({ preventScroll: true });
		if (openInst === close) openInst = null;
	};
	const choose = (i) => {
		const changed = sel.selectedIndex !== i;
		sel.selectedIndex = i;
		paint(); close(true);
		if (changed) sel.dispatchEvent(new Event("change", { bubbles: true }));
	};
	const filter = (q) => {
		const n = q.trim().toLowerCase();
		let any = false;
		list.querySelectorAll(".ds-sel__opt").forEach((li) => { const hit = !n || li.textContent.toLowerCase().includes(n); li.hidden = !hit; any = any || hit; });
		wrap.querySelector(".ds-sel__empty").hidden = any;
		const v = visible(); if (v.length) setActive(+v[0].dataset.i);
	};
	const move = (d) => {
		const v = visible(); if (!v.length) return;
		const pos = v.findIndex((li) => +li.dataset.i === active);
		setActive(+v[(pos + d + v.length) % v.length].dataset.i);
	};
	const keys = (e) => {
		if (e.key === "ArrowDown") { e.preventDefault(); pop.hidden ? open() : move(1); }
		else if (e.key === "ArrowUp") { e.preventDefault(); pop.hidden ? open() : move(-1); }
		else if (e.key === "Enter" || (e.key === " " && e.target !== search)) { e.preventDefault(); pop.hidden ? open() : choose(active); }
		else if (e.key === "Escape") { e.stopPropagation(); close(true); }
		else if (e.key === "Tab") close();
		else if (!search && e.key.length === 1 && !pop.hidden) {
			const li = visible().find((x) => x.textContent.trim().toLowerCase().startsWith(e.key.toLowerCase()));
			if (li) setActive(+li.dataset.i);
		}
	};
	btn.addEventListener("click", () => (pop.hidden ? open() : close(true)));
	btn.addEventListener("keydown", keys);
	pop.addEventListener("keydown", keys);
	list.addEventListener("click", (e) => { const li = e.target.closest(".ds-sel__opt:not(.is-dis)"); if (li) choose(+li.dataset.i); });
	list.addEventListener("mousemove", (e) => { const li = e.target.closest(".ds-sel__opt"); if (li && +li.dataset.i !== active) setActive(+li.dataset.i); });
	search?.addEventListener("input", () => filter(search.value));
	sel.addEventListener("change", paint);
	sel.form?.addEventListener("reset", () => setTimeout(paint));
	paint();
}

// Rebuild after the options changed (e.g. the delivery city list loads after the page).
export function refreshSelect(sel) {
	const wrap = sel.closest(".ds-sel");
	if (wrap && sel.dataset.enhanced) {
		wrap.parentNode.insertBefore(sel, wrap);
		wrap.remove();
		delete sel.dataset.enhanced;
		sel.classList.remove("ds-sel__native");
		sel.removeAttribute("aria-hidden");
		sel.removeAttribute("tabindex");
	}
	enhance(sel);
}

export function initSelects(root = document) {
	$$("select", root).forEach(enhance);
	document.addEventListener("click", (e) => { if (openInst && !e.target.closest(".ds-sel.is-open")) openInst(); });
}
